// Copyright 2022, Imprivata, Inc.  All rights reserved.

import { Flex, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

// P8 Link no longer valid. Identical for unknown, expired and terminal links, and it must not
// depend on platform context or any tenant fetch so the caller always sees this message.
const LinkNoLongerValid: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Flex vertical align="center" data-testid="link-no-longer-valid">
      <Typography.Title level={2} className="text-center" data-testid="link-no-longer-valid-title">
        {t('serviceDesk.link-no-longer-valid-title')}
      </Typography.Title>
      <Typography.Paragraph className="text-center" data-testid="link-no-longer-valid-body">
        {t('serviceDesk.link-no-longer-valid-body')}
      </Typography.Paragraph>
    </Flex>
  );
};
export default LinkNoLongerValid;
